/** @jsx jsx */
import {  useMemo } from "react"
import { css, jsx } from '@emotion/react'
import { useStaticQuery, graphql } from "gatsby";
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SectionHeadline from '../../../components/SectionHeadline';
import CardList from '../../../components/CardList'
import { useLocalization } from "gatsby-theme-i18n";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import AnimatedSection from '../../../components/AnimatedSection';
import { DateTime } from 'luxon';
import RoundButton from '../../../components/RoundButton';


const ProgramSection = () => {

  const { t, localeKey, currentLocaleObj } = useLocalization();
  const data = useStaticQuery(graphql`
  query ProgramSection {
    background : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_program.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    programsList: allProgram(
      sort: {fields: order, order: ASC}
      filter: {data: {status: {eq: "publish"}, pickup: {eq: "true"}}}
    ) {
      edges {
        node {
          annotation {
            ...localizedContent
          }
          title {
            ...localizedContent
          }
          time {
            ...localizedContent
          }
          data{
            update_date
            type
            stream_url
            status
            start_time
            key
            end_time
            date
          }
          desc {
            ...localizedContent
          }
          performers { ...localizedContent }

          guests {
            name { ...localizedContent }
            title { ...localizedContent }
            tooltip { ...localizedContent }
            image {
              childImageSharp {
                gatsbyImageData(
                  quality: 90
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
            thumb {
              childImageSharp {
                gatsbyImageData(
                  quality: 90
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
          }

          thumb {
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: NONE
              )
            }
          }
          visual {
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: NONE
              )
            }
          }
        }
      }
    }
  }
`);

const programsList = useMemo(() => {
  if(data.programsList)
  {
    let list = [];
     data.programsList.edges.forEach((item) => {
      list.push({
        category: '',
        title: item.node.title ? item.node.title[localeKey] : '',
        desc: item.node.desc ? item.node.desc[localeKey] : '',
        image: getImage(item.node.thumb),
        visual : getImage(item.node.visual),
        data: item.node.data,
        time: item.node.time ? item.node.time[localeKey] : '',
        isNew: DateTime.fromISO(item.node.data.update_date).diff(DateTime.local(), [ 'days']).values.days > -3,
        annotation : item.node.annotation ? item.node.annotation[localeKey] : '',
        guests : item.node.guests,
        performers : item.node.performers ? item.node.performers[localeKey] : '',
        streamingUrl : item.node.data.stream_url
      });
    });

    return list;
  } else {
    return [];
  }

  
},[data,localeKey ]);

  return (
    <SectionWrapper id="section_program" className={`programList`}>
      <AnimatedSection>
        <Content>
          <SectionHeadline title={t('home.program.title')} subtitle={t('home.program.subtitle')} color={'#D00F31'} icon={'Meteor'}/>
          <CardList colNum={3} list={programsList} isFull={"true"} hvModal={true}/>
          <ButtonContainer>
            <RoundButton color={"#4E4E50"} size={"large"} fixedwidth="true" fade to={`/${currentLocaleObj.prefix}/program/timetable`} css={css`
              width:auto;
              font-size: 28px;
              line-height: 32px;
              padding-top:14px;
              padding-bottom:14px; 
              height: auto;
              border-radius: 48px;
              margin-right:32px;

              @media only screen and (max-width: ${breakpoint.smMax}){
                font-size: 17px;
                line-height: 24px;
                height:auto;
                padding:10px 24px;
                margin-right:24px;
              }

              @media only screen and (max-width: ${breakpoint.xsMax}){
                font-size: 14px;
                line-height: 20px;
                display:block;
                padding-top:6px;
                padding-bottom:6px; 
                width: 100%;
                border-radius: 32px;
                margin-right:0px;
                margin-bottom:8px;
              }

            `}>
              {t('home.program.timetable.button')}
            </RoundButton>
            <RoundButton color={"#F50057"} size={"large"} fixedwidth="true" fade to={`/${currentLocaleObj.prefix}/program/`} css={css`
              width:auto;
              font-size: 28px;
              line-height: 32px;
              padding-top:16px;
              padding-bottom:16px; 
              height: auto;
              border-radius: 48px;

              @media only screen and (max-width: ${breakpoint.smMax}){
                font-size: 17px;
                line-height: 24px;
                height:auto;
                padding:12px 24px;
              }

              @media only screen and (max-width: ${breakpoint.xsMax}){
                font-size: 14px;
                line-height: 20px;
                display:block;
                padding-top:8px;
                padding-bottom:8px; 
                width: 100%;
                border-radius: 32px;
              }

            `}>
              {t('home.program.detail.button')}
            </RoundButton>
          </ButtonContainer>
        </Content>
      </AnimatedSection>
      <Background><GatsbyImage image={getImage(data.background)} alt={"background"} /></Background>
    </SectionWrapper>
  );
};


export default ProgramSection;

const SectionWrapper = styled.div`
  background:#F7F7FA;
  display:flex;
  align-items:center;
  position:relative;
  padding:96px 0;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
    min-height:728px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    
    padding:32px 0;
    min-height:0;
  }
  
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  overflow:hidden;
  z-index:5;
  max-width: calc(960px + 96px);

  @media only screen and (max-width: ${breakpoint.smMax}){
    .sectionHeadline{
      padding:0 80px;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    .sectionHeadline{
      padding:0 24px;
    }
  }
`

const Background = styled.div`
  width:720px;
  height:auto;
  position:absolute;
  top:0;
  left:0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:359px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:none;
  }
`

const ButtonContainer = styled.div`
  text-align:center;

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:24px;
  }
`
